module.exports = function () {
    $('.careers-search-hero.careers-search-hero--animate').addClass('careers-search-hero--is-animated');    
};